import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const Layout = () => (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      <nav className="bg-white shadow-md p-4 flex items-center">
        <Link to="/" className="mr-4 hover:text-blue-600">
          Dashboard
        </Link>
        <Link to="/members" className="hover:text-blue-600">
          Members
        </Link>
        <button
          onClick={() => {
          localStorage.clear();
          window.location = '/login';
          }}  
          className="ml-auto px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
        >
          Logout
        </button>
      </nav>

      <main className="p-6">
        <Outlet />
      </main>
  </div>
);

export default Layout;
